import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexRow } from "app/components/React/Table/cells/DomainListWithTooltip/styled";
import { NAVIGATION_SIDEBAR_WIDTH } from "app/pages/activation/constants/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const MainContainer = styled(FlexColumn)`
    align-items: center;
    gap: 16px;

    padding: 0 44px 48px calc(${NAVIGATION_SIDEBAR_WIDTH}px + 44px);

    @media (min-width: 1920px) {
        padding: 0 120px 48px calc(${NAVIGATION_SIDEBAR_WIDTH}px + 120px);
    }
`;

export const WidgetHeader = styled(FlexRow)`
    box-sizing: border-box;
    align-items: center;
    gap: 16px;
    width: 100%;
    min-height: 68px;
    padding: 16px 0;
    position: relative;
`;

export const WidgetTitle = styled.h6<{ isWidgetHover?: boolean; isTitleLink?: boolean }>`
    ${setFontVariant("h6", colorsPalettes.carbon[500])};
    margin: 0;

    ${({ isWidgetHover, isTitleLink }) => {
        if (isTitleLink && !isWidgetHover) {
            return css`
                cursor: pointer;

                &:hover {
                    color: ${colorsPalettes.blue[400]};
                    text-decoration: underline;
                }
            `;
        }

        if (isWidgetHover) {
            return css`
                color: ${colorsPalettes.blue[400]};
                text-decoration: underline;
            `;
        }
    }}
`;

export const GAFooter = styled(FlexRow)`
    border-top: 1px solid ${colorsPalettes.carbon[50]};
    padding: 8px 16px;
    justify-content: end;
    background: ${colorsPalettes.carbon[0]};
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
`;
